module.exports = __webpack_public_path__ + "img/arrow_left.50f638b5.png";